export default "__VITE_ASSET__C7U8k$1g__"